import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import ContactForm from './ContactForm';
import MenuContact from '../../components/MenuContact';
import PageIntroBanner from '../../components/PageIntroBanner';
import { colors, typography } from '../../styles';

const styles = css`

  .ContactInfo_heading {
    font-family: ${typography.Serif};
    color: ${colors.color1};
    font-weight:700;
  }
  main {
    padding:20px 0;
    @media (min-width: 480px) {
      padding:40px 0;
    }
    @media (min-width: 768px) {
      padding:60px 0;
    }
  }
`;

const formStyles = css``;

function ContactUs({ page, builder }) {
  return (
    <div className={styles}>
      <PageWrapper>
        <PageHelmet page={page} />
        <InsideHeader
          h1={`${page.meta.name}`}
          background={get(page, 'page_image.contentUrl')}
        />
        <MenuContact />
        {get(page, 'page_intro_banner[0].heading') &&
          <PageIntroBanner
            heading={get(page, 'page_intro_banner[0].heading')}
            body={get(page, 'page_intro_banner[0].text')}
            image={get(page, 'page_intro_banner[0].image.contentUrl')}
          />
        }
        <main>
          <div className="container">
            <div className="row">
              <div className="col-lg-3 mb-3">
                <address>
                  <h3 className="ContactInfo_heading">{get(builder, 'name')}</h3>
                  <p>
                    {get(builder, 'address.streetAddress')}<br />
                    {get(builder, 'address.addressLocality')}, {get(builder, 'address.addressRegion')} {get(builder, 'address.postalCode')}<br />
                    <strong><a className="brand-color" href={`tel:${get(builder, 'telephone').replace(/[^0-9]/g, '')}`}>{get(builder, 'telephone').replace(/\s-\s/, '-')}</a></strong>
                  </p>
                </address>
                {
                  get(page, 'body_copy') &&
                  <div className="PageReadable_Body" dangerouslySetInnerHTML={SanitizeHtml(get(page, 'body_copy'))} />
                }
              </div>
              <div className="col-lg-8 ml-auto">
                <ContactForm className={formStyles} noRedirect />
              </div>
            </div>
          </div>
        </main>
      </PageWrapper>
    </div>
  );
}

ContactUs.propTypes = {
  page: PropTypes.object.isRequired,
  builder: PropTypes.object.isRequired,
};

export default withData({
  builder: true,
  page: 'contact_us',
})(ContactUs);



// WEBPACK FOOTER //
// ./src/pages/ContactUs/index.js